import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-94eeb7ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notifications" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "notifications__cards"
}
const _hoisted_4 = { class: "notifications__cards-item" }
const _hoisted_5 = { class: "notifications__cards-item-info" }
const _hoisted_6 = { class: "gradient-color" }
const _hoisted_7 = { class: "items-in-line" }
const _hoisted_8 = { class: "notifications__item-info-date third-color" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 0,
  class: "items-in-line flex-end"
}
const _hoisted_11 = {
  key: 2,
  class: "mt--20 pt--20 pb--20"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center allBlockWidth" }, "Уведомлений нет", -1))
const _hoisted_13 = [
  _hoisted_12
]

import { computed, onMounted, ref, Ref } from 'vue';
import { NotificationsTypeFromBack } from '@/api/notification/types';
import { useUserStore } from '@/store/modules/user';
import { replaceLinksInText } from '@/utils/Common/Common';


export default /*#__PURE__*/_defineComponent({
  __name: 'Notifications',
  setup(__props) {

const isLoading = ref(false);
const closeNotificationsLoading: Ref<number[]> = ref([]);

const notifications = computed((): NotificationsTypeFromBack => {
  return useUserStore().notifications;
});
const prepareNotifications: Ref<NotificationsTypeFromBack> = ref(notifications.value);
const closeNotification = async (id: number) => {
  closeNotificationsLoading.value.push(id);
  try {
    await useUserStore().closeNotificationById(id);
  } finally {
    const index = closeNotificationsLoading.value.findIndex(el => el === id);

    if (index >= 0) {
      closeNotificationsLoading.value.splice(index, 1);
    }
  }
};

onMounted(async () => {
  isLoading.value = true;

  try {
    await useUserStore().getNotifications();
  } finally {
    isLoading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_base_skeleton_loader = _resolveComponent("base-skeleton-loader")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_card = _resolveComponent("base-card")!
  const _component_base_pagination_group = _resolveComponent("base-pagination-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
            return _createVNode(_component_base_skeleton_loader, {
              key: i,
              styles: { height: '94px', width: '100%' },
              class: "mb--5 mt--20",
              type: "mediumText"
            })
          }), 64))
        ]))
      : (prepareNotifications.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prepareNotifications.value, (item) => {
              return (_openBlock(), _createBlock(_component_base_card, {
                key: item.id,
                "full-width-mobile": ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(new Date(item.created_at).toLocaleString()), 1),
                        _createElementVNode("div", {
                          class: _normalizeClass([{ unread: !item.close }, "notifications__cards-status"])
                        }, null, 2)
                      ])
                    ]),
                    _createElementVNode("div", {
                      innerHTML: _unref(replaceLinksInText)(item.message)
                    }, null, 8, _hoisted_9),
                    (!item.close || item.channel_id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          (item.channel_id)
                            ? (_openBlock(), _createBlock(_component_base_button, {
                                key: 0,
                                href: {
                params: { id: 'chat' },
                query: {
                  id: item.channel_id,
                },
              },
                                "style-type": "coloredBorder",
                                text: "Чат"
                              }, null, 8, ["href"]))
                            : _createCommentVNode("", true),
                          (!item.close)
                            ? (_openBlock(), _createBlock(_component_base_button, {
                                key: 1,
                                loading: closeNotificationsLoading.value.includes(item.id),
                                text: "Закрыть",
                                onClick: ($event: any) => (closeNotification(item.id))
                              }, null, 8, ["loading", "onClick"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13)),
    (notifications.value.length || isLoading.value)
      ? (_openBlock(), _createBlock(_component_base_pagination_group, {
          key: 3,
          modelValue: prepareNotifications.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((prepareNotifications).value = $event)),
          "is-loading": isLoading.value,
          "max-for-visible": 15,
          values: notifications.value,
          "auto-add-mobile": "",
          class: "mt--30"
        }, null, 8, ["modelValue", "is-loading", "values"]))
      : _createCommentVNode("", true)
  ]))
}
}

})